import React from "react";
import { APP_STORE_QR_SRC, APP_STORE_URL } from "../config/appStore";

const DownloadScreen = () => {
  return (
    <div className="screen" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', background: '#0a0a0a' }}>
      <div
        className="card"
        style={{
          maxWidth: 520,
          width: '100%',
          margin: '48px auto',
          textAlign: 'center',
          padding: 48,
          borderRadius: 36,
          background: 'rgba(24, 28, 40, 0.85)',
          boxShadow: '0 8px 40px #0008',
          backdropFilter: 'blur(12px)',
          border: '1.5px solid rgba(255,255,255,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h1 className="screen-title" style={{ marginBottom: 18, fontSize: '2.6rem', fontWeight: 900, color: '#fff', letterSpacing: 1 }}>Download InvestX for iOS</h1>
        <p style={{ color: '#94A3B8', marginBottom: 40, fontSize: '1.25rem' }}>
          Get InvestX on the App Store, or scan the QR code with your iPhone:
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <div style={{ marginBottom: 14, fontWeight: 700, fontSize: '1.15rem', color: '#fff' }}>App Store</div>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open InvestX on the App Store"
            style={{
              width: 180,
              height: 180,
              background: '#fff',
              borderRadius: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 24px #0006',
              marginBottom: 16,
              padding: 12,
              boxSizing: 'border-box',
            }}
          >
            <img
              src={APP_STORE_QR_SRC}
              alt="QR code linking to InvestX on the App Store"
              width={156}
              height={156}
              style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </a>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#22D3EE', fontWeight: 600, textDecoration: 'none', fontSize: '1rem' }}
          >
            Download on the App Store
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadScreen;
